module.exports = __webpack_public_path__ + "img/car_work.6666ade4.svg";